/**
 * Installations Reducer
 *
 */
import { Map, fromJS } from "immutable";
import * as CONST from "actions/action_constants";

const installations = (state = Map({}), action) => {
  const { list, installationID, installationData } = action;
  switch (action.type) {
    case CONST.INSTALLATIONS_FETCH_SUCCESS:
      return state.merge(list);
    case CONST.INSTALLATION_FETCH_SUCCESS:
      // Get existing installation data if it exists, otherwise start with empty Map
      const existingInstallation = state.get(installationID, Map({}));
      // Merge the new partial data into the existing installation data
      const updatedInstallation = existingInstallation.merge(fromJS(installationData));
      return state.set(installationID, updatedInstallation);
    case CONST.INSTALLATION_CREATE_SUCCESS:
      const _installationID = installationData._id;
      return state.merge(
        fromJS({ [_installationID]: { ...installationData } })
      );
    case CONST.INSTALLATION_CREATE_REVERT_COPY:
      return state.set("revertCopy", state.get(action.installationID));
    case CONST.INSTALLATION_REVERT_CHANGES:
      const revertData = state.get("revertCopy").toJS();
      revertData.isSaved = true;
      const revertInstallationID = revertData._id;
      return state.set(revertInstallationID, fromJS(revertData));
    case CONST.INSTALLATION_PUBLISH_REQUEST:
      // Clear out the publish status for the installation
      return state.setIn([installationID, "publishStatus"], "");
    case CONST.LOGOUT_SUCCESS:
      return state.clear();
    case CONST.INSTALLATION_PROP_CHANGE:
      const selector = [];
      selector.push(installationID, action.prop);
      return state
        .setIn(selector, action.value)
        .setIn([installationID, "isSaved"], false);
    case CONST.INSTALLATION_DELETE_SUCCESS:
      return state.remove(installationID);
    default:
      return state;
  }
};

export default installations;
